import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { TokenUserPayload } from '@/core/models/token.model';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  decodeToken(token: string): TokenUserPayload | null {
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('error decoding tokenJWT:', error);
      return null;
    }
  }
}